import script from "./IDateRangePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./IDateRangePicker.vue?vue&type=script&setup=true&lang=js"

import "./IDateRangePicker.vue?vue&type=style&index=0&id=0e4b60bd&lang=scss"

const __exports__ = script;

export default __exports__